// extracted by mini-css-extract-plugin
module.exports = {"main":"MainComponent_main__3DPZu"};